<template>
	<div>
		<AdminNav v-if="auth.view == 'admin'"></AdminNav>
		<UserNav v-if="auth.view == 'user'"></UserNav>
	</div>
</template>

<script>

	import UserNav from "@/components/assessment/content/UserNav"
	import AdminNav from "@/components/admin/content/AdminNav"
	import Vuex from "vuex"
	export default {
		name: "Navigation", 
		computed: {
			...Vuex.mapState({
				auth: state => state.auth, 
				user: state => state.user
			}),
			dashboard(){
				return this.auth.view == "admin" ? "/admin" : "dashboard" 
			}
		},
		data: () => {
			return {
			}
		}, 
		components: {
			UserNav, 
			AdminNav
		},
		methods: {
		}
	}
</script>